<script lang="ts">
    import {
        ParticipantCardFragmentDoc,
        type ParticipantProfileLinkFragment,
    } from '$gql/graphql';
    import ParticipantCard from '$components/ParticipantCard/ParticipantCard.svelte';
    import { useFragment } from '$gql';

    export let participant: ParticipantProfileLinkFragment;
    export let withCard = false;
    export let target: '_blank' | undefined = '_blank';

    export let rel: string | undefined = 'noreferrer';
    export let label: string | null = null;

    let className = '';
    export { className as class };
</script>

{#if withCard}
    <ParticipantCard participant={useFragment(ParticipantCardFragmentDoc, participant)}>
        <slot {participant}>
            <a
                href={participant.participantProfileLink}
                {rel}
                {target}
                class={className}
                data-sveltekit-reload={true}
            >
                {label ?? participant.participantName}
            </a>
        </slot>
    </ParticipantCard>
{:else}
    <slot {participant}>
        <a
            href={participant.participantProfileLink}
            {rel}
            {target}
            class={className}
            data-sveltekit-reload={true}
        >
            {label ?? participant.participantName}
        </a>
    </slot>
{/if}
